import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import ShowCard from '../components/ShowCard';
import { ArrowLeft, ListMusic } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PlaylistDetailPage() {
  const { slug } = useParams();
  const [playlist, setPlaylist] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/playlists/${slug}`)
      .then(r => { setPlaylist(r.data); setLoading(false); })
      .catch(() => setLoading(false));
  }, [slug]);

  if (loading) return (
    <div className="page-content flex items-center justify-center min-h-[60vh]">
      <div className="animate-pulse"><div className="h-8 bg-gray-200 rounded w-48" /></div>
    </div>
  );

  if (!playlist) return (
    <div className="page-content flex items-center justify-center min-h-[60vh]">
      <p className="font-['Fredoka'] text-2xl text-[#4B5563]">Playlist not found</p>
    </div>
  );

  return (
    <div className="page-content">
      <div className="max-w-7xl mx-auto px-6 md:px-8 lg:px-12 py-8">
        <Link to="/playlists" className="inline-flex items-center gap-1 text-sm font-bold text-[#FF3860] hover:underline mb-6" data-testid="back-to-playlists">
          <ArrowLeft size={16} strokeWidth={2.5} /> Back to Playlists
        </Link>

        <div className="neo-card p-6 md:p-8 mb-8 bg-[#FDFBEC]" data-testid="playlist-header">
          <div className="flex items-center gap-3 mb-3">
            <ListMusic size={24} strokeWidth={2.5} className="text-[#FF3860]" />
            <h1 className="font-['Fredoka'] text-3xl sm:text-4xl font-black text-[#0A0A0A] tracking-tight">
              {playlist.title}
            </h1>
          </div>
          <p className="text-base text-[#4B5563] font-['Nunito'] mb-2">{playlist.description}</p>
          <span className="text-xs font-bold text-[#4B5563] font-['IBM_Plex_Mono']">{playlist.show_count} shows</span>
        </div>

        {playlist.shows?.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 stagger-children">
            {playlist.shows.map((show, i) => (
              <div key={show.id} className="animate-fade-in-up" style={{ opacity: 0 }}>
                <ShowCard show={show} index={i} />
              </div>
            ))}
          </div>
        ) : (
          <p className="text-center py-12 text-[#4B5563] font-['Nunito']">No shows in this playlist yet</p>
        )}
      </div>
    </div>
  );
}
